import { render } from "./SegmentationSimpleProperty.vue?vue&type=template&id=b1749316&scoped=true"
import script from "./SegmentationSimpleProperty.vue?vue&type=script&lang=ts"
export * from "./SegmentationSimpleProperty.vue?vue&type=script&lang=ts"

import "./SegmentationSimpleProperty.vue?vue&type=style&index=0&id=b1749316&lang=scss&scoped=true"
import "./SegmentationSimpleProperty.vue?vue&type=style&index=1&id=b1749316&lang=scss"
script.render = render
script.__scopeId = "data-v-b1749316"

export default script